import classNames from 'classnames';
import { LabelBreadcrumbsActive } from '../features/modules/components';
import { LabelProps } from '../features/modules/components/Label';

type Props = LabelProps & {};
export function Caption({
    color = 'text-dark-red',
    className,
    ...props
}: Props) {
    return (
        <LabelBreadcrumbsActive
            {...props}
            color={color}
            className={classNames(
                className,
                'w-fit rounded bg-interactive-surface px-10',
            )}
        />
    );
}
